import React, { useEffect, useState } from 'react';
import { GetViewType } from "../../../utils/view-type";
import { useTranslation } from "react-i18next";
import Sort from "../../sort/sort";
import Search from "../../search/search";
import { Close, DeleteIcon, EditIcon, FormIcon, FormIconPure, KeyIcon, MailIcon, RedCloseIcon } from "../../../icons/icons";
import Filter from "../../filter/filter";
import CustomInput from "../../UI/customInput/customInput";
import CustomButton from "../../UI/customButton/customButton";
import DropDown from "../../../assets/dropDown/dropDown";
import Pagination from "../../pagination/pagination";
import { useDispatch, useSelector } from "react-redux";
import { Delete, Get } from "../../../apis/api";
import { setting } from "../../../store/setting/setting.reducer";
import { toast } from "react-toastify";
import LoadingFix from "../../loading-fix/loading-fix";
import DeleteModal from "../../deleteModal/deleteModal";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
import { CONST } from "../../../utils/CONST";
import { VisaOrderRow } from './components/VisaOrderRow'
import clsx from 'clsx';
import { VisaStatus } from '../../VisaStatus/VisaStatus';
import { Filters } from './components/Filters'
import { useVisaOrdersPage } from './hooks';

export const NewVisaOrderTable = ({ defaultValue, editItem }) => {
  const [idModal, setIdModal] = useState(false)
  const viewType = GetViewType()
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [deleteItem, setDeleteItem] = useState(null)
  const [perPage, setPerPage] = useState(10)
  const [loadingDelete, setLoadingDelete] = useState(false)
  const dispatch = useDispatch()
  const [searchTime, setSearchTime] = useState("")
  const lng = useSelector((state) => state.common.lng)
  const user = useSelector((state) => state.user.user)
  const isAgent = user?.role_key === "agent"

  const { selectedStatuses } = useVisaOrdersPage()


  const navigate = useNavigate()
  useEffect(() => {
    handleList()
  }, [])

  useEffect(() => {
    setData(defaultValue)
  }, [defaultValue])

  const handleList = (page, per_page, search = "") => {
    setLoading(true)
    const statusQuery = selectedStatuses.length == 0 ? '' : `&status=${selectedStatuses.join(',')}`
    Get(user?.role_key === "agent"
      ? `agent/visas?page=${page || 1}&per_page=${per_page || 10}&q=${search}`
      : `admin/visas?page=${page || 1}&per_page=${per_page || 10}&q=${search}${statusQuery}`).then((res) => {
        setData(res?.details?.data)
      }).finally(() => {
        setLoading(false)
      })
  }


  useEffect(() => {
    handleList()
  }, [selectedStatuses])


  const handleEdit = (item) => {
    editItem(item)
  }
  const handleDelete = (item) => {
    setDeleteItem(item)
  }

  const handleCloseDeleteModal = () => {
    setDeleteItem(null)
  }

  const handleDeleteRequest = () => {
    setLoadingDelete(true)
    Delete(`basic-information/city/destroy/${deleteItem.id}`).then((res) => {
      setData(res?.details?.data)
      dispatch(setting({ city: res?.details?.data?.data }))
      toast.success(res.msg)
      setDeleteItem(null)
    }).finally(() => {
      setLoadingDelete(false)
    })
  }

  const handleSort = (e) => {
    setData([])
    setTimeout(() => {
      setData(e)
    }, 0)
  }
  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleList(1, perPage, e);

    }, 1000)
    setSearchTime(loop)

  }

  const NoVisaListComponent = () => {
    if (data?.data?.length != 0) return <></>
    
    if (selectedStatuses.length == 0)
      return <span className='text-center w-full text-gray-500 text-sm'>{t('NoVisaFound')}</span>
    else
      return <span className='text-center w-full text-gray-500 text-sm'>{t('NoVisaWithThisStatusFound')}</span>

  }


  return (
    <div className={"my-container"}>
      {
        loading && <LoadingFix />
      }
      {
        deleteItem && <DeleteModal onClose={handleCloseDeleteModal} onDelete={handleDeleteRequest} loading={loadingDelete} />
      }

      {!loading && <Filters />}
      {
        viewType === "WEB" ?
          <div
            className="relative overflow-x-auto w-full  bg-white rounded-lg flex flex-col gap-4  items-stretch !mt-5 border border-1 border-gray-200 overflow-hidden pb-4">
            <div className={clsx(' grid  gap-2 w-full p-4 text-sm text-gray-600 uppercase text-center grid-cols-8')}>
              <span className='col-span-1'>{t("applicationNumber")}</span>
              <span className='col-span-1'>{t("visaType")}</span>
              {!isAgent && <span className='col-span-1'> {t("agent")}</span>}
              <span className='col-span-1'>{t("crew")}</span>
              <span className='col-span-1'>{t("jobs")}</span>
              <span className='col-span-1'>{t("requestDate")}</span>
              <span className='col-span-1'>{t("status")}</span>
              <span className='col-span-1'>{t("automationNumber")}</span>
              {isAgent && <span className='col-span-1'>{t("Operation")}</span>}

            </div>

            <div className='bg-gray-100 w-full h-[1px]'></div>
            {data?.data?.map((item, index) => {
              return item.crews.map((crew, crew_index) => <VisaOrderRow onSuccessMutate={handleList} key={`${item?.id}-${crew?.id}`} {...item} crews={[crew]} />)
            })}
            <NoVisaListComponent/>
          </div>
          :
          <div className={"grid gap-3 mt-3"}>
            <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter />
              <div className={"w-full"}>
                <Search onChange={handleSearch} />
              </div>
            </div>
            {
              data?.data?.map((item, index) => {
                return (
                  <div className={"flex p-4 rounded-lg bg-white"}>
                    <div className={"flex w-full"}>
                      <div className={"mx-1 min-w-7"}>{index + 1}</div>
                      <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                        <div className={"flex w-full justify-between"}>
                          <div className={"flex w-1/2 flex-col"}>
                            {item?.crew?.name + " " + item?.crew?.last_name}
                          </div>
                          <div className={"flex w-1/2 justify-end text-end text-sm"}> {item.visa[`${lng}_name`]}</div>
                        </div>
                        <div className={"flex w-full justify-between items-center"}>
                          <div className={"flex w-1/4 text-sm text-gray-900 text-center justify-end"}>
                            <VisaStatus status={item.visa.status} />
                          </div>
                          <div className={"flex w-1/3 text-sm text-gray-900 justify-center text-center"}>{item.visa.expired_at && moment(item.visa.expired_at).format(lng === "en" ? "YYYY-MM-DD" : "jYYYY-jMM-jDD")}</div>
                          <div className={"flex justify-between cursor-pointer"}>
                            <div onClick={() => setIdModal(true)}>
                              <MailIcon />
                            </div>
                            {
                              user?.role_key === "super_admin" &&
                              <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
                                {!(item?.visa?.status === 0 || item?.visa?.status === 1) ? <FormIconPure /> : <FormIcon />}
                              </div>
                            }

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }

            <NoVisaListComponent/>

          </div>
      }
      <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
        <DropDown onChange={(per_page) => {
          handleList(1, per_page)
          setPerPage(per_page)
        }} />
        <Pagination itemsPerPage={data?.per_page} total={data?.total} last_page={data?.last_page} changePage={(page) => handleList(page, perPage)} />
      </div>
    </div>
  );
};
